import React from 'react';
import './PC.css';
import Amazon from '../../img/pc/Amazon.png'
import Angelov from '../../img/pc/Angelov.png'
import Apiumhub from '../../img/pc/Apiumhub.png'
import askui from '../../img/pc/askui.png'
import AutomateThePlanet from '../../img/pc/AutomateThePlanet.png'
import BT from '../../img/pc/BT.png'
import Capgemini from '../../img/pc/Capgemini.png'
import Jiménez from '../../img/pc/Jiménez.png'
import Kinsbruner from '../../img/pc/Kinsbruner.png'
import Menesklou from '../../img/pc/Menesklou.png'
import Perforce from '../../img/pc/Perforce.png'
import Sunder from '../../img/pc/Sunder.png'
import Thoughtworks from '../../img/pc/Thoughtworks.png'
import Upton from '../../img/pc/Upton.png'
import Valderrama from '../../img/pc/Valderrama.png'
import Velayutham from '../../img/pc/Velayutham.png'
import Charlton from '../../img/pc/Charlton.png'
import Functionize from '../../img/pc/Functionize.png'
import Chestnut from '../../img/pc/Chestnut.png'
import Thrasio from '../../img/pc/Thrasio.png'
import Marcetic from '../../img/pc/Marcetic.png'
import TarabaTech from '../../img/pc/TarabaTech.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Upton,
          name: 'Steve Upton',
          position: 'Lead QA Consultant',
          ln: 'https://www.linkedin.com/in/stevejupton/',
          tw: 'https://twitter.com/Steve_Upton',
          logo: Thoughtworks,
        },
        {
          photo: Menesklou,
          name: 'Jonas Menesklou',
          position: 'CEO',
          ln: 'https://www.linkedin.com/in/menesklou/',
          tw: 'https://twitter.com/JonasMenesklou',
          logo: askui,
        },
        // {
        //   photo: Chestnut,
        //   name: 'Erika Chestnut',
        //   position: 'Head of Quality and Process Engineering',
        //   ln: 'https://www.linkedin.com/in/erikachestnut/',
        //   logo: Thrasio,
        // },
        {
          photo: Kinsbruner,
          name: 'Eran Kinsbruner',
          position: 'DevOps Chief Evangelist, Author',
          ln: 'https://www.linkedin.com/in/erankinsbruner/',
          tw: 'https://twitter.com/ek121268',
          logo: Perforce,
        },
        {
          photo: Charlton,
          name: 'Jenna Charlton',
          position: 'Product Owner',
          tw: 'https://twitter.com/TheyWrestleTest',
          logo: Functionize,
        },
        {
          photo: Jiménez,
          name: 'Kilian Jiménez',
          position: 'Senior QA Automation',
          ln: 'https://www.linkedin.com/in/kilian-jimenez/',
          logo: Apiumhub,
        },
        {
          photo: Angelov,
          name: 'Anton Angelov',
          position: 'CTO',
          ln: 'https://www.linkedin.com/in/angelovstanton',
          tw: 'https://twitter.com/angelovstanton',
          website: 'https://www.amazon.com/dp/B08XWFM6V8',
          logo: AutomateThePlanet,
        },
        // {
        //   photo: Marcetic,
        //   name: 'Minja Marčetić',
        //   position: 'Head of Quality Assurance',
        //   ln: 'https://www.linkedin.com/in/minja-marcetic/ ',
        //   logo: TarabaTech,
        // },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}